var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { parseError } from "@ane/core/lib/utils/ErrorUtils";
import { getNewGuid } from "@ane/core/lib/utils/CommonStringUtils";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const apiVersion = "1.0-preview.1";
let MessageListResource = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.notificationHub, "", parseError);
  }
  getMessagesCount(workspaceId, lastMessageId) {
    return __async(this, null, function* () {
      let requestId = getNewGuid();
      let address = `/workspaces/${workspaceId}/messages/count?apiVersion=${apiVersion}&lastMessageId=${lastMessageId}&requestId=${requestId}`;
      const result = yield this._get(address);
      return result;
    });
  }
  getMessageList(workspaceId, loadCount, needNewMessage, lastMessageId) {
    return __async(this, null, function* () {
      let top = loadCount;
      let address = `/workspaces/${workspaceId}/messages?apiVersion=${apiVersion}&top=${top}&lastMessageId=${lastMessageId}&needNewMessage=${needNewMessage}`;
      const result = yield this._get(address);
      return result;
    });
  }
  dismissMessage(workspaceId, messageId) {
    return __async(this, null, function* () {
      let address = `/workspaces/${workspaceId}/messages/${messageId}/dismiss?apiVersion=${apiVersion}`;
      const result = yield this._post(null, address);
      return result;
    });
  }
  dismissAllMessages(workspaceId, lastMessageId) {
    return __async(this, null, function* () {
      let address = `/workspaces/${workspaceId}/messages/dismissAll?apiVersion=${apiVersion}&lastMessageId=${lastMessageId}`;
      const result = yield this._post(null, address);
      return result;
    });
  }
  getUpsellMessageList(workspaceId, loadCount) {
    return __async(this, null, function* () {
      let top = loadCount;
      let address = `/workspaces/${workspaceId}/upsell?apiVersion=${apiVersion}&top=${top}`;
      const result = yield this._get(address);
      return result;
    });
  }
  dismissUpsellMessage(workspaceId, upsellNotificationId) {
    return __async(this, null, function* () {
      let address = `/workspaces/${workspaceId}/upsell/${upsellNotificationId}/dismiss?apiVersion=${apiVersion}`;
      const result = yield this._post(null, address);
      return result;
    });
  }
  dismissAllUpsellMessages(workspaceId) {
    return __async(this, null, function* () {
      let address = `/workspaces/${workspaceId}/upsell/dismissAll?apiVersion=${apiVersion}`;
      const result = yield this._post(null, address);
      return result;
    });
  }
};
MessageListResource = __decorateClass([
  WPSProxyConverter()
], MessageListResource);
const MessagesResource = new MessageListResource();
export {
  MessagesResource as default
};
//# sourceMappingURL=Messages.resource.js.map
